import { API, setAuthToken } from '../../../config/API.js';
import { GET_PROVINSI, SET_LOADING_PROVINSI, SET_PAGINATION_PROVINSI } from '../constant.js';

export const getProvinsi = (params) => {
  return (dispatch) => {
    const token = localStorage.getItem("jwt_token");
    setAuthToken(token);
    dispatch({
      type: SET_LOADING_PROVINSI,
      payload: true,
    });
    API.get(`admin/province?${new URLSearchParams(params).toString()}`)
      .then((res) => {
        dispatch({
          type: GET_PROVINSI,
          payload: params?.paginate === false ? res?.data : res.data.data || [],
        });
        dispatch({
          type: SET_PAGINATION_PROVINSI,
          payload: res?.data?.data?.last_page,
        });
      })
      .catch(() => {
        dispatch({
          type: GET_PROVINSI,
          payload: [],
        });
        dispatch({
          type: SET_PAGINATION_PROVINSI,
          payload: 0,
        });
      });
  };
};

export const addProvinsi = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/province/add", params);
};

export const getDetailProvinsi = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.get(`admin/province/${code}`);
};

export const updProvinsi = (params) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.post("admin/province/edit", params);
};

export const delProvinsi = (code) => {
  const token = localStorage.getItem("jwt_token");
  setAuthToken(token);
  return API.delete("admin/province/delete/" + code);
};
